import { TableBody } from '@lmig/lmds-react-table';

interface ISimpleTableProps {
  tableObject: any[];
  nameProp: string;
  valueProp: string;
}
export function SimpleTable({ tableObject, nameProp, valueProp }: ISimpleTableProps) {
  return (
    <>
      <table className="table simple-table">
        <TableBody>
          {tableObject.map((tableObj) => (
            <tr>
              <td style={{ fontWeight: 700 }}>{typeof tableObj === 'string' ? tableObj : tableObj[nameProp]}</td>
              {typeof tableObj !== 'string' && <td style={{ maxWidth: '200px' }}>{String(tableObj[valueProp])}</td>}
            </tr>
          ))}
        </TableBody>
      </table>
    </>
  );
}
